/**
 *
 * None: The 'None' value is assigned to vehicles.
 * Sales: Indicates that the location is used for point of sale transactions.
 * Dispatch: Indicates that the location is used for receiving online orders.
 * SalesAndDispatch: Indicates that the location is used for both point of sale transactions and receiving online orders.
 * Receiving: Indicates that the location is used for receiving goods and products, and is assigned to consumer default accounts.
 *
 */

export enum LocationUsageType {
  None,
  Sales,
  Dispatch,
  SalesAndDispatch,
  Receiving,
  Production,
}
